export const ZERNIKEPARAMS = {
  params: [
    {
      index: 0,
      nIndex: 0,
      mIndex: 0,
      selected: false,
      enabled: true,
      value: -1000
    },
    {
      index: 1,
      nIndex: 1,
      mIndex: -1,
      selected: false,
      enabled: true,
      value: -1000
    },
    {
      index: 2,
      nIndex: 1,
      mIndex: 1,
      selected: false,
      enabled: true,
      value: -1000
    },
    {
      index: 3,
      nIndex: 2,
      mIndex: -2,
      selected: false,
      enabled: true,
      value: -1000
    },
    {
      index: 4,
      nIndex: 2,
      mIndex: 0,
      selected: false,
      enabled: true,
      value: -1000
    },
    {
      index: 5,
      nIndex: 2,
      mIndex: 2,
      selected: false,
      enabled: true,
      value: -1000
    },
    {
      index: 6,
      nIndex: 3,
      mIndex: -3,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 7,
      nIndex: 3,
      mIndex: -1,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 8,
      nIndex: 3,
      mIndex: 1,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 9,
      nIndex: 3,
      mIndex: 3,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 10,
      nIndex: 4,
      mIndex: -4,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 11,
      nIndex: 4,
      mIndex: -2,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 12,
      nIndex: 4,
      mIndex: 0,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 13,
      nIndex: 4,
      mIndex: 2,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 14,
      nIndex: 4,
      mIndex: 4,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 15,
      nIndex: 5,
      mIndex: -5,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 16,
      nIndex: 5,
      mIndex: -3,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 17,
      nIndex: 5,
      mIndex: -1,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 18,
      nIndex: 5,
      mIndex: 1,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 19,
      nIndex: 5,
      mIndex: 3,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 20,
      nIndex: 5,
      mIndex: 5,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 21,
      nIndex: 6,
      mIndex: -6,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 22,
      nIndex: 6,
      mIndex: -4,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 23,
      nIndex: 6,
      mIndex: -2,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 24,
      nIndex: 6,
      mIndex: 0,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 25,
      nIndex: 6,
      mIndex: 2,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 26,
      nIndex: 6,
      mIndex: 4,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 27,
      nIndex: 6,
      mIndex: 6,
      selected: true,
      enabled: true,
      value: -1000
    },
    {
      index: 28,
      nIndex: 7,
      mIndex: -7,
      selected: false,
      enabled: false,
      value: -1000
    },
    {
      index: 29,
      nIndex: 7,
      mIndex: -5,
      selected: false,
      enabled: false,
      value: -1000
    },
    {
      index: 30,
      nIndex: 7,
      mIndex: -3,
      selected: false,
      enabled: false,
      value: -1000
    },
    {
      index: 31,
      nIndex: 7,
      mIndex: -1,
      selected: false,
      enabled: false,
      value: -1000
    },
    {
      index: 32,
      nIndex: 7,
      mIndex: 1,
      selected: false,
      enabled: false,
      value: -1000
    },
    {
      index: 33,
      nIndex: 7,
      mIndex: 3,
      selected: false,
      enabled: false,
      value: -1000
    },
    {
      index: 34,
      nIndex: 7,
      mIndex: 5,
      selected: false,
      enabled: false,
      value: -1000
    },
    {
      index: 35,
      nIndex: 7,
      mIndex: 7,
      selected: false,
      enabled: false,
      value: -1000
    },
    {
      index: 36,
      nIndex: 8,
      mIndex: -8,
      selected: false,
      enabled: false,
      value: -1000
    },
    {
      index: 37,
      nIndex: 8,
      mIndex: -6,
      selected: false,
      enabled: false,
      value: -1000
    },
    {
      index: 38,
      nIndex: 8,
      mIndex: -4,
      selected: false,
      enabled: false,
      value: -1000
    },
    {
      index: 39,
      nIndex: 8,
      mIndex: -2,
      selected: false,
      enabled: false,
      value: -1000
    },
    {
      index: 40,
      nIndex: 8,
      mIndex: 0,
      selected: false,
      enabled: false,
      value: -1000
    },
    {
      index: 41,
      nIndex: 8,
      mIndex: 2,
      selected: true,
      enabled: false,
      value: -1000
    },
    {
      index: 42,
      nIndex: 8,
      mIndex: 4,
      selected: true,
      enabled: false,
      value: -1000
    },
    {
      index: 43,
      nIndex: 8,
      mIndex: 6,
      selected: false,
      enabled: false,
      value: -1000
    },
    {
      index: 44,
      nIndex: 8,
      mIndex: 8,
      selected: false,
      enabled: false,
      value: -1000
    }
  ]
};
export const MAPDRAWPARAMS = {
  largemap: {
    mapInForm0: {
      mapIndexUI: 1,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        // ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        // ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        ShowMaxMin: false,
        Show3579Ring: false
      }
    }
  },
  fourmaps: {
    mapInForm0: {
      mapIndexUI: 1,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        // ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        // ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        ShowMaxMin: false,
        Show3579Ring: false
      }
    },
    mapInForm1: {
      mapIndexUI: 3,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        // ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        // ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        ShowMaxMin: false,
        Show3579Ring: false
      }
    },
    mapInForm2: {
      mapIndexUI: 5,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        // ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        // ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        ShowMaxMin: false,
        Show3579Ring: false
      }
    },
    mapInForm3: {
      mapIndexUI: 9,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        // ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        // ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        ShowMaxMin: false,
        Show3579Ring: false
      }
    }
  },
  factorforms: {
    mapInForm0: {
      mapIndexUI: 1,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        // ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        // ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        ShowMaxMin: false,
        Show3579Ring: false
      }
    },
    mapInForm1: {
      mapIndexUI: 3,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        // ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        // ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        ShowMaxMin: false,
        Show3579Ring: false
      }
    }
  },
  fourierAnalysis: {
    mapInForm0: {
      mapIndexUI: 3,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        Show3579Ring: false
      }
    },
    mapInForm1: {
      mapIndexUI: 3,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        Show3579Ring: false
      }
    },
    mapInForm2: {
      mapIndexUI: 3,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        Show3579Ring: false
      }
    },
    mapInForm3: {
      mapIndexUI: 3,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        Show3579Ring: false
      }
    },
    mapInForm4: {
      mapIndexUI: 3,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        Show3579Ring: false
      }
    }
  },
  keratoconus: {
    mapInForm0: {
      mapIndexUI: 3,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        ShowMaxMin: false,
        Show3579Ring: false
      }
    },
    mapInForm1: {
      mapIndexUI: 5,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        Show3579Ring: false
      }
    }
  },
  zernike: {
    mapInForm0: {
      mapIndexUI: 5,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        // ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        // ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        ShowMaxMin: false,
        Show3579Ring: false
      }
    }
  },
  contectlens: {
    mapInForm0: {
      mapIndexUI: 15,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        // ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        // ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        ShowMaxMin: false,
        Show3579Ring: false
      }
    }
  },
  compare2records: {
    mapInForm0: {
      mapIndexUI: 1,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        // ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        // ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        ShowMaxMin: false,
        Show3579Ring: false
      }
    },
    mapInForm1: {
      mapIndexUI: 3,
      shapes: {
        ShowApexPosition: false,
        ShowMinRadiusF: false,
        // ShowPupilCenter: false,
        ShowAlpha: false,
        ShowMaxPeak: false,
        // ShowPupilEdge: false,
        ShowNasalTemp: false,
        ShowEyeType: true,
        ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false,
        ShowMaxMin: false,
        Show3579Ring: false
      }
    },
    mapInForm2: {
      mapIndexUI: 5,
      shapes: {
        // ShowApexPosition: false,
        // ShowMinRadiusF: false,
        // ShowPupilCenter: false,
        // ShowAlpha: false,
        // ShowMaxPeak: false,
        // ShowPupilEdge: false,
        // ShowNasalTemp: false,
        // ShowEyeType: true,
        // ShowNinemmBorder: false,
        ShowDiameter9mm: false,
        ShowNumericValues: false
        // ShowMaxMin: false,
        // Show3579Ring: false
      }
    }
  }
};
export const DATASHOW = {
  isCartesian: false,
  isDiameter: true,
  medianMode: 0,
  mm: 6,
  isRhRv: true,
  showEdge: true,
  showFitData: false
};
export const COLORBARSHOW = {
  largemap0: {
    curvature: {
      bar: "AbsNormal",
      style: "standard",
      step: 0,
      num: 61,
      unit: "D"
    },
    elevation: {
      bar: "AbsNormal",
      style: "standard",
      step: 2.5,
      num: 61,
      unit: "μm"
    }
  },
  fourmaps0: {
    curvature: {
      bar: "AbsNormal",
      style: "standard",
      step: 0,
      num: 61,
      unit: "D"
    },
    elevation: {
      bar: "AbsNormal",
      style: "standard",
      step: 2.5,
      num: 61,
      unit: "μm"
    }
  },
  fourmaps1: {
    curvature: {
      bar: "AbsNormal",
      style: "standard",
      step: 0,
      num: 61,
      unit: "D"
    },
    elevation: {
      bar: "AbsNormal",
      style: "standard",
      step: 2.5,
      num: 61,
      unit: "μm"
    }
  },
  fourmaps2: {
    curvature: {
      bar: "AbsNormal",
      style: "standard",
      step: 0,
      num: 61,
      unit: "D"
    },
    elevation: {
      bar: "AbsNormal",
      style: "standard",
      step: 2.5,
      num: 61,
      unit: "μm"
    }
  },
  fourmaps3: {
    curvature: {
      bar: "AbsNormal",
      style: "standard",
      step: 0,
      num: 61,
      unit: "D"
    },
    elevation: {
      bar: "AbsNormal",
      style: "standard",
      step: 2.5,
      num: 61,
      unit: "μm"
    }
  },
  mainMeridian0: {
    curvature: {
      bar: "AbsNormal",
      style: "standard",
      step: 0,
      num: 61,
      unit: "D"
    },
    elevation: {
      bar: "AbsNormal",
      style: "standard",
      step: 2.5,
      num: 61,
      unit: "μm"
    }
  },
  mainMeridian1: {
    curvature: {
      bar: "AbsNormal",
      style: "standard",
      step: 0,
      num: 61,
      unit: "D"
    },
    elevation: {
      bar: "AbsNormal",
      style: "standard",
      step: 2.5,
      num: 61,
      unit: "μm"
    }
  },

  keratoconus0: {
    curvature: {
      bar: "AbsNormal",
      style: "standard",
      step: 0,
      num: 61,
      unit: "D"
    },
    elevation: {
      bar: "AbsNormal",
      style: "standard",
      step: 2.5,
      num: 61,
      unit: "μm"
    }
  },
  keratoconus1: {
    curvature: {
      bar: "AbsNormal",
      style: "standard",
      step: 0,
      num: 61,
      unit: "D"
    },
    elevation: {
      bar: "AbsNormal",
      style: "standard",
      step: 2.5,
      num: 61,
      unit: "μm"
    }
  },
  keratoconus2: {
    curvature: {
      bar: "AbsNormal",
      style: "standard",
      step: 0,
      num: 61,
      unit: "D"
    },
    elevation: {
      bar: "AbsNormal",
      style: "standard",
      step: 2.5,
      num: 61,
      unit: "μm"
    }
  },
  contectlens0: {
    rgp: {
      bar: "RelFine",
      style: "fluorescence",
      num: 61,
      step: 150,
      unit: "D"
    },
    curvature: {
      bar: "AbsNormal",
      style: "standard",
      step: 0,
      num: 61,
      unit: "D"
    },
    elevation: {
      bar: "AbsNormal",
      style: "standard",
      step: 2.5,
      num: 61,
      unit: "μm"
    }
  },
  compare: {
    curvature: {
      bar: "AbsNormal",
      style: "standard",
      step: 0,
      num: 61,
      unit: "D"
    },
    elevation: {
      bar: "AbsNormal",
      style: "standard",
      step: 2.5,
      num: 61,
      unit: "μm"
    }
  },
  compareDiff: {
    curvature: {
      bar: "RelFine",
      style: "standard",
      step: 0.25,
      num: 61,
      unit: "D"
    },
    elevation: {
      bar: "AbsNormal",
      style: "standard",
      step: 2.5,
      num: 61,
      unit: "μm"
    }
  }
};
export const CAMPLAMP = {
  topography_near: {
    filter: 1,
    lamp: {
      ir: 0,
      b: 0,
      w: 22,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 8,
      ggain: 7.2,
      bgain: 7.68,
      gamma: 0.95,
      blacklevel: 0.39
    }
  },
  topography_far: {
    filter: 2,
    lamp: {
      ir: 0,
      b: 0,
      w: 22,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 8,
      ggain: 7.2,
      bgain: 7.68,
      gamma: 0.95,
      blacklevel: 0.39
    }
  },
  // pupilcorneadia: {
  //   filter: 4,
  //   lamp: {
  //     ir: 35,
  //     b: 0,
  //     w: 0,
  //     g: 100
  //   },
  //   cam: {
  //     mode: 1,
  //     rgain: 2.2,
  //     ggain: 2.2,
  //     bgain: 2.2,
  //     gamma: 1.01,
  //     blacklevel: 0.3
  //   }
  // },
  pupilcorneadia: {
    filter: 4,
    lamp: {
      ir: 100,
      b: 0,
      w: 0,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 2.2,
      ggain: 2.2,
      bgain: 2.2,
      gamma: 1.01,
      blacklevel: 0.3
    }
  },
  // 暗视
  pupilcorneadia_dark: {
    filter: 6,
    lamp: {
      ir: 70,
      b: 0,
      w: 0,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 3.0,
      ggain: 3.0,
      bgain: 3.0,
      gamma: 1.0,
      blacklevel: 0.3
    }
  },
  // 低中视
  pupilcorneadia_lowerMiddle: {
    filter: 6,
    lamp: {
      ir: 70,
      b: 0,
      w: 15,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 3.0,
      ggain: 3.0,
      bgain: 3.0,
      gamma: 1.0,
      blacklevel: 0.3
    }
  },
  //中视
  pupilcorneadia_middle: {
    filter: 6,
    lamp: {
      ir: 70,
      b: 0,
      w: 30,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 3.0,
      ggain: 3.0,
      bgain: 3.0,
      gamma: 1.0,
      blacklevel: 0.3
    }
  },
  //明视
  pupilcorneadia_bright: {
    filter: 6,
    lamp: {
      ir: 70,
      b: 0,
      w: 100,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 3.0,
      ggain: 3.0,
      bgain: 3.0,
      gamma: 1.0,
      blacklevel: 0.3
    }
  },
  //动态瞳孔
  pupilcorneadia_dynamic: {
    filter: 6,
    lamp: {
      ir: 70,
      b: 0,
      w: 100,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 3.0,
      ggain: 3.0,
      bgain: 3.0,
      gamma: 1.0,
      blacklevel: 0.3
    }
  },
  nibut: {
    filter: 2,
    lamp: {
      ir: 0,
      b: 0,
      w: 40,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 8,
      ggain: 7.2,
      bgain: 7.68,
      gamma: 0.95,
      blacklevel: 0.39
    }
  },
  nibut_infrared: {
    filter: 6,
    lamp: {
      ir: 50,
      b: 0,
      w: 0,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 2.5,
      ggain: 2.5,
      bgain: 2.5,
      gamma: 1.0,
      blacklevel: 0.3
    }
  },
  ocularsurface: {
    filter: 5,
    lamp: {
      ir: 0,
      b: 60,
      w: 0,
      g: 100
    },
    cam: {
      mode: 3,
      rgain: 7.2,
      ggain: 7.2,
      bgain: 7.18,
      gamma: 1.3,
      blacklevel: 0.3
    }
  },
  eyelidedge: {
    filter: 3,
    lamp: {
      ir: 0,
      b: 0,
      w: 40,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 5,
      ggain: 4.5,
      bgain: 5,
      gamma: 0.7,
      blacklevel: 0.3
    }
  },
  tearheight: {
    filter: 3,
    lamp: {
      ir: 0,
      b: 0,
      w: 40,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 5,
      ggain: 4.5,
      bgain: 5,
      gamma: 0.6,
      blacklevel: 0.3
    }
  },
  tearheight_infrared: {
    filter: 6,
    lamp: {
      ir: 50,
      b: 0,
      w: 0,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 2.5,
      ggain: 2.5,
      bgain: 2.5,
      gamma: 1.0,
      blacklevel: 0.3
    }
  },
  lipidlayer: {
    filter: 2,
    lamp: {
      ir: 0,
      b: 0,
      w: 40,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 8,
      ggain: 7.2,
      bgain: 7.68,
      gamma: 1,
      blacklevel: 0.45
    }
  },
  eyeredness: {
    filter: 3,
    lamp: {
      ir: 0,
      b: 0,
      w: 40,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 5,
      ggain: 4.5,
      bgain: 5,
      gamma: 0.6,
      blacklevel: 0.3
    }
  },
  meibomian: {
    filter: 4,
    lamp: {
      ir: 35,
      b: 0,
      w: 0,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 1,
      ggain: 1,
      bgain: 1,
      gamma: 1,
      blacklevel: 0.3
    }
  },
  fbut: {
    filter: 5,
    lamp: {
      ir: 0,
      b: 50,
      w: 0,
      g: 100
    },
    cam: {
      mode: 3,
      rgain: 7.2,
      ggain: 7.2,
      bgain: 7.18,
      gamma: 1.3,
      blacklevel: 0.3
    }
  },
  blink: {
    filter: 4,
    lamp: {
      ir: 35,
      b: 0,
      w: 0,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 2.2,
      ggain: 2.2,
      bgain: 2.2,
      gamma: 0.73,
      blacklevel: 0.15
    }
  },
  blink_nature: {
    filter: 3,
    lamp: {
      ir: 0,
      b: 0,
      w: 40,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 5,
      ggain: 4.5,
      bgain: 5,
      gamma: 0.6,
      blacklevel: 0.3
    }
  }
};

export const CAMPLAMP_OLD = {
  topography_near: {
    filter: 1,
    lamp: {
      ir: 0,
      b: 0,
      w: 22,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 8,
      ggain: 7.2,
      bgain: 7.68,
      gamma: 0.95,
      blacklevel: 0.39
    }
  },
  topography_far: {
    filter: 2,
    lamp: {
      ir: 0,
      b: 0,
      w: 22,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 8,
      ggain: 7.2,
      bgain: 7.68,
      gamma: 0.95,
      blacklevel: 0.39
    }
  },
  // pupilcorneadia: {
  //   filter: 4,
  //   lamp: {
  //     ir: 35,
  //     b: 0,
  //     w: 0,
  //     g: 100
  //   },
  //   cam: {
  //     mode: 1,
  //     rgain: 2.2,
  //     ggain: 2.2,
  //     bgain: 2.2,
  //     gamma: 1.01,
  //     blacklevel: 0.3
  //   }
  // },
  pupilcorneadia: {
    filter: 4,
    lamp: {
      ir: 100,
      b: 0,
      w: 0,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 2.2,
      ggain: 2.2,
      bgain: 2.2,
      gamma: 1.01,
      blacklevel: 0.3
    }
  },
  // 暗视
  pupilcorneadia_dark: {
    filter: 6,
    lamp: {
      ir: 40,
      b: 0,
      w: 0,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 3.0,
      ggain: 3.0,
      bgain: 3.0,
      gamma: 1.0,
      blacklevel: 0.3
    }
  },
  // 低中视
  pupilcorneadia_lowerMiddle: {
    filter: 6,
    lamp: {
      ir: 40,
      b: 0,
      w: 15,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 3.0,
      ggain: 3.0,
      bgain: 3.0,
      gamma: 1.0,
      blacklevel: 0.3
    }
  },
  //中视
  pupilcorneadia_middle: {
    filter: 6,
    lamp: {
      ir: 40,
      b: 0,
      w: 30,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 3.0,
      ggain: 3.0,
      bgain: 3.0,
      gamma: 1.0,
      blacklevel: 0.3
    }
  },
  //明视
  pupilcorneadia_bright: {
    filter: 6,
    lamp: {
      ir: 40,
      b: 0,
      w: 100,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 3.0,
      ggain: 3.0,
      bgain: 3.0,
      gamma: 1.0,
      blacklevel: 0.3
    }
  },
  //动态瞳孔
  pupilcorneadia_dynamic: {
    filter: 6,
    lamp: {
      ir: 40,
      b: 0,
      w: 100,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 3.0,
      ggain: 3.0,
      bgain: 3.0,
      gamma: 1.0,
      blacklevel: 0.3
    }
  },
  nibut: {
    filter: 2,
    lamp: {
      ir: 0,
      b: 0,
      w: 40,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 8,
      ggain: 7.2,
      bgain: 7.68,
      gamma: 0.95,
      blacklevel: 0.39
    }
  },
  nibut_infrared: {
    filter: 6,
    lamp: {
      ir: 50,
      b: 0,
      w: 0,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 2.5,
      ggain: 2.5,
      bgain: 2.5,
      gamma: 1.0,
      blacklevel: 0.3
    }
  },
  ocularsurface: {
    filter: 5,
    lamp: {
      ir: 0,
      b: 60,
      w: 0,
      g: 100
    },
    cam: {
      mode: 3,
      rgain: 7.2,
      ggain: 7.2,
      bgain: 7.18,
      gamma: 1.3,
      blacklevel: 0.3
    }
  },
  eyelidedge: {
    filter: 3,
    lamp: {
      ir: 0,
      b: 0,
      w: 40,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 5,
      ggain: 4.5,
      bgain: 5,
      gamma: 0.7,
      blacklevel: 0.3
    }
  },
  tearheight: {
    filter: 3,
    lamp: {
      ir: 0,
      b: 0,
      w: 40,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 5,
      ggain: 4.5,
      bgain: 5,
      gamma: 0.6,
      blacklevel: 0.3
    }
  },
  lipidlayer: {
    filter: 2,
    lamp: {
      ir: 0,
      b: 0,
      w: 40,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 8,
      ggain: 7.2,
      bgain: 7.68,
      gamma: 1,
      blacklevel: 0.45
    }
  },
  eyeredness: {
    filter: 3,
    lamp: {
      ir: 0,
      b: 0,
      w: 40,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 5,
      ggain: 4.5,
      bgain: 5,
      gamma: 0.6,
      blacklevel: 0.3
    }
  },
  meibomian: {
    filter: 4,
    lamp: {
      ir: 35,
      b: 0,
      w: 0,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 1,
      ggain: 1,
      bgain: 1,
      gamma: 1,
      blacklevel: 0.3
    }
  },
  fbut: {
    filter: 5,
    lamp: {
      ir: 0,
      b: 50,
      w: 0,
      g: 100
    },
    cam: {
      mode: 3,
      rgain: 7.2,
      ggain: 7.2,
      bgain: 7.18,
      gamma: 1.3,
      blacklevel: 0.3
    }
  },
  blink: {
    filter: 4,
    lamp: {
      ir: 35,
      b: 0,
      w: 0,
      g: 100
    },
    cam: {
      mode: 1,
      rgain: 2.2,
      ggain: 2.2,
      bgain: 2.2,
      gamma: 0.73,
      blacklevel: 0.15
    }
  },
  blink_nature: {
    filter: 3,
    lamp: {
      ir: 0,
      b: 0,
      w: 40,
      g: 100
    },
    cam: {
      mode: 0,
      rgain: 5,
      ggain: 4.5,
      bgain: 5,
      gamma: 0.6,
      blacklevel: 0.3
    }
  }
};

export const CONFIGPARAMS = {
  MotorP: {
    JawMax: "8191",
    JawMin: "0",
    JawSpeedMax: "250",
    JawSpeedMin: "0",
    UDMax: "4000",
    UDMin: "0",
    UDSpeedMax: "255",
    UDSpeedMin: "120",
    LRMax: "124395",
    LRMin: "0",
    LRSpeedMax: "895",
    LRSpeedMin: "255",
    NBMax: "70690",
    NBMin: "0",
    NBSpeedMax: "895",
    NBSpeedMin: "255",
    XTime: "1024",
    YTime: "704",
    ZTime: "416",
    UnValidNum: "100",
    CENTER_R: "100"
  },
  ControlP: {
    iTime: "20",
    XYZHomeRatio: "85",
    UDPosCenter: "384",
    UDPosLimitV: "3",
    UDPosRank: "10, 20, 30",
    UDSpeedRank: "10, 20, 30",
    LRPosCenter: "512",
    LRPosLimitV: "3",
    LRPosRank: "10, 20, 30",
    LRSpeedRank: "15, 30, 60",
    NBPosCenter: "384",
    NBPosFocusV: "6000",
    NBPosRank: "10, 20, 30",
    NBSpeedRank: "30, 45, 60"
  },
  CamParaW2W: {
    GainA: "8",
    GainR: "1",
    GainG: "1",
    GainB: "1",
    BlackB: "0.3",
    Gamma: "0.6"
  },
  CamParaP: {
    GainA: "8",
    GainR: "5",
    GainG: "5",
    GainB: "5",
    BlackB: "0.3",
    Gamma: "0.6"
  }
};
export const EXPORT_OPTION_SELECTED = {
  folderName: ["name", "pid", "checktype", "eye", "checktime"],
  exportOptions: {
    dryeye: {
      checked: true,
      children: {
        dryeyecsv: true,
        tearheight: true,
        nibut: true,
        lipidlayer: true,
        meibomian: true,
        eyelidedge: true,
        eyeredness: true,
        ocularsurface: true
        // blink: true,
        // fbut: true
      }
    },
    topography: {
      checked: true,
      children: {
        topocsv: true,
        originalimage: true,
        dotEyeFile: true,
        dotMwfFile: true
      }
    }
  }
};
export const EXPORT_OPTIONS = {
  folderName: ["name", "pid", "checktype", "eye", "checktime"],
  exportOptions: {
    dryeye: {
      checked: false,
      children: {
        dryeyecsv: false,
        tearheight: false,
        nibut: false,
        lipidlayer: false,
        meibomian: false,
        eyelidedge: false,
        eyeredness: false,
        ocularsurface: false,
        blink: false,
        fbut: false
      }
    },
    topography: {
      checked: false,
      children: {
        topocsv: false,
        originalimage: false,
        dotEyeFile: false,
        dotMwfFile: false
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/settings/consts.js